import { AuthProvider } from "context/AuthContext";
import { BookmarkProvider } from "context/BookmarkContext";
import { DialogProvider } from "context/DialogContext";
import { OrganiseListProvider } from "context/OrganiseListContext";
import { PropertyProvider } from "context/PropertyContext";
import { SaveSearchProvider } from "context/SaveSearchContext";
import { SearchProvider } from "context/SearchContext";
import { SearchFilterProvider } from "context/SearchFilterContext";
import { SubscriptionProvider } from "context/SubscriptionContext";
import React from "react";

const AppProviders = ({ children }) => {
  return (
    <AuthProvider>
      <DialogProvider>
        <SubscriptionProvider>
          <OrganiseListProvider>
            <SearchProvider>
              <SaveSearchProvider>
                <PropertyProvider>
                  <SearchFilterProvider>
                    <BookmarkProvider>{children}</BookmarkProvider>
                  </SearchFilterProvider>
                </PropertyProvider>
              </SaveSearchProvider>
            </SearchProvider>
          </OrganiseListProvider>
        </SubscriptionProvider>
      </DialogProvider>
    </AuthProvider>
  );
};

export default AppProviders;
